import type { JSX } from 'react';
import type { Placement } from 'react-aria';
import { Menu, MenuItem, MenuTrigger, Popover, Text } from '@launchpad-ui/components';

import styles from './FilterSelectionPopover.module.css';

interface FilterSelectionPopoverProps {
  children: JSX.Element;
  onSelectContextKind: () => void;
  onSelectEventProperty: () => void;
  placement?: Placement;
}

export const FilterSelectionPopover: React.FC<FilterSelectionPopoverProps> = ({
  children,
  onSelectContextKind,
  onSelectEventProperty,
  placement = 'bottom left',
}) => (
  <MenuTrigger>
    {children}
    <Popover className={styles.filterPopover} placement={placement}>
      <Menu>
        <MenuItem onAction={onSelectContextKind}>
          <Text slot="label">Context attribute</Text>
          <Text slot="description">
            Filter the event by an attribute of a context kind e.g. <code>user</code> or <code>account</code> associated
            with this event.
          </Text>
        </MenuItem>
        <MenuItem onAction={onSelectEventProperty}>
          <Text slot="label">Event property</Text>
          <Text slot="description">
            Filter the event by metadata sent in the SDK's track method e.g. <code>client.track('eventKey');</code>
          </Text>
        </MenuItem>
      </Menu>
    </Popover>
  </MenuTrigger>
);
